import React, { Fragment } from 'react'
import { FlipContainer } from '../../../UI/FlipContainer/FlipContainer'
import { usePutAway } from '../../Context/usePutAway'
import { HistoryPutAway } from '../HistoryPutAway/HistoryPutAway'
import { LocateSKUPutAway } from '../LocateSKUPutAway'
import FlipButtonBack from './FlipButtonBack'
import { ProductProblemsPutAway } from '../ProductProblemsPutAway'

export default function LocateHistoryPutAway() {
  const { state } = usePutAway()
  const { isFlipped: flipState } = state

  const getBackView = (backViewCode: number) => {
    switch (backViewCode) {
      case 1:
        return <HistoryPutAway />
      case 2:
        return <ProductProblemsPutAway />
      default:
        return <Fragment />
    }
  }

  return (
    <FlipContainer
      frontView={<LocateSKUPutAway />}
      backView={getBackView(flipState.option)}
      button={<FlipButtonBack />}
      isFlipped={flipState.isFlipped}
    />
  )
}
